import { PickObjectPropertiesHelperBase } from './PickObjectPropertiesHelperBase';
export class PickSymbolObjectPropertiesHelper extends PickObjectPropertiesHelperBase {
    getObjectProperty(sb) {
        return sb.helpers.getSymbolObjectProperty;
    }
    setObjectDataProperty(sb) {
        return sb.helpers.setDataSymbolObjectProperty;
    }
}

//# sourceMappingURL=PickSymbolObjectPropertiesHelper.js.map
